import { Button, Form, Modal } from "react-bootstrap";
import { onSuccess, useApiMutation } from "../utils/api";
import { useForm } from "react-hook-form";

export const EditModal = ({ idea, board, close, refetch }: any) => {
  const { post } = useApiMutation();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      title: idea.title,
      image: idea.image,
      cost: idea.cost,
      link: idea.link,
      board_id: idea.board_id,
    },
  });

  const onSubmit = (data: any) => {
    post(`/api/user/update_idea/${idea.id}`, { idea: data }).then(
      onSuccess(() => {
        refetch();
        close();
      })
    );
  };

  const handleDelete = () => {
    if (confirm("Delete this idea?")) {
      post(`/api/user/delete_idea/${idea.id}`).then(
        onSuccess(() => {
          refetch();
          close();
        })
      );
    }
  };

  return (
    <Modal show={true} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Idea</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Title"
              {...register("title", { required: true })}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Image</Form.Label>
            <Form.Control type="text" placeholder="Image URL" {...register("image")} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Cost</Form.Label>
            <Form.Control placeholder="Cost" {...register("cost")} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Link</Form.Label>
            <Form.Control type="text" placeholder="Link" {...register("link")} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>
            <Form.Select {...register("board_id")}>
              {board.family.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button variant="link text-danger no-underline" onClick={handleDelete}>
              <i className="far fa-trash-alt" />
            </Button>
            <div>
              <Button variant="primary" type="submit">
                Save
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
